import ReactGA from 'react-ga4';
import { useMemo, useState } from "react";
import { Button } from "../../../components/Button";
import AlertIcon from "../../../assets/icons/Alert.svg?react";

import { ClientQuizFormType } from "./ClientQuiz";
import { SelectInput } from "../../../components/SelectInput";

export function Step2({
  onNext,
  clientQuizForm: form,
  setClientQuizForm: setForm
}: {
  onNext: () => void;
  clientQuizForm: ClientQuizFormType;
  setClientQuizForm: (value: ClientQuizFormType) => void;
}) {
  const [errors, setErrors] = useState({} as any);
  const [error, setError] = useState<string>("");
  const [saving, setSaving] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;



    setForm({ ...form, [name]: value } as ClientQuizFormType);
  };

  const validateAndNext = async (e) => {
    e.preventDefault();

    let newErrors = {};

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return
    }

    if (import.meta.env.VITE_ENV === "prod") {
      if (form.autismDiagnosis === "YES") {
        ReactGA.event("quiz-autismDiagnosis-yes")
      }
      if (form.autismDiagnosis === "NO") {
        ReactGA.event("quiz-autismDiagnosis-no")
      }
      if (form.autismDiagnosis === "IN_PROCESS") {
        ReactGA.event("quiz-autismDiagnosis-in-process")
      }
    }

    onNext();
  };

  const disabled = useMemo(() => {
    return !form.autismDiagnosis
  }, [form]);

  return (
    <>
      <div className="bg-white p-8 rounded-[16px]">
        <form className="mt-4 flex flex-col gap-[22px]" onSubmit={validateAndNext}>
          <div className="flex flex-col md:flex-row items-center gap-3">
            <div className="w-full lg:w-[50%]  flex flex-col gap-1.5">
            <div className="text-primary font-bold">2.</div>
              <label className="text-lg text-black/80">
                Has your child been diagnosed with autism?
              </label>
                <SelectInput
                name="autismDiagnosis"
                disabledOptionText="Select an option"
                data={[
                  { value: 'YES', label: 'Yes' },
                  { value: 'NO', label: 'No' },
                  { value: 'IN_PROCESS', label: 'In the process' }
                ]}
                value={form.autismDiagnosis}
                onChange={handleChange}
              />
              {errors.autismDiagnosis && (
                <div className="text-red-500 text-xs font-medium">
                  {errors.autismDiagnosis}
                </div>
              )}
            </div>
            <div />
          </div>

          <div className="mt-7">
            {error && (
              <div className="text-red-500 text-xs font-medium mb-4 flex items-center gap-1">
                <AlertIcon /> {error}
              </div>
            )}
            <Button
              type="submit"
              variant="primary"
              className="!rounded-full w-full"
              disabled={disabled || saving}
              loading={saving}
              onClick={validateAndNext}
            >
              Next
            </Button>
          </div>
        </form>
      </div>

    </>
  );
}
